import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { PaymentMethod } from '../../../utils/enums';

export const Container = styled.div`
    display: flex;
    flex: 1;
`;

export const DetailsFormContainer = styled.div`
    flex: 1;
    padding: 1em;
    display: flex;
    flex-direction: column;
`;

export const AnimatiedFormContainer = styled.div`
    &.transition-enter {
        opacity: 1;
    }

    &.transition-enter-active {
        opacity: 1;
        transition: all 300ms;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit-active {
        opacity: 0;
        transition: all 300ms;
    }
`;

export const DisclaimerContainer = styled.div`
    margin-top: 8px;
`;

export const Info = styled.span`
    font-size: 14px;
    height: 20px;
    opacity: ${props => (props.visible ? 0 : 1)};
    transition: all 250ms ease;
`;

export const FormSectionContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
`;

export const SmallFormGroup = styled.div`
    margin-bottom: ${props => props.marginBottom || '0.5em'};
    margin-top: ${props => props.marginTop || '0'};
`;

export const BackLink = styled.div`
    font-family: Lato;
    font-size: 12px;
    line-height: 1.33;
    color: #008eff;
    font-weight: normal;
    cursor: pointer;
    text-align: right;
    display: ${props => (props.hidden ? 'none' : 'block')};
`;

export const FormGroupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin: 0 -0.5em;
    align-items: center;

    > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin: 0 0.5em;
    }
`;

export const BottomGroup = styled.div`
    display: flex;
    flex-direction: column;
    flex: ${props => (props.showCreditCardForm ? 1 : 0.5)};
    justify-content: flex-end;
`;

export const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

const DefaultDisclaimerContainer = styled.div`
    font-family: Lato;
    font-size: 8px;
    line-height: 1.33;
    color: #979191;
    width: 100%;

    @media (min-width: 30em) {
        width: 135px;
    }
`;

const getDisclaimerText = paymentMethod => {
    let disclaimerText = '';

    if (paymentMethod === PaymentMethod.Braintree)
        disclaimerText = 'Payment processed by Braintree, a PayPal company.';

    if (paymentMethod === PaymentMethod.OrgHunter) {
        disclaimerText = 'Payment processed by OrgHunter.';
    }
    return disclaimerText;
};

export const Disclaimer = props => (
    <DefaultDisclaimerContainer>
        {getDisclaimerText(props.paymentMethod)}
    </DefaultDisclaimerContainer>
);

Disclaimer.propTypes = {
    paymentMethod: PropTypes.string.isRequired
};

export const PaymentButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
